// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"6ad194ca","498":"89b9a3fa","598":"3a9ee24e","703":"5549a629"}[chunkId] + ".chunk.js";
};